import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import PT from 'prop-types';
import styled from 'styled-components';
import { Checkbox, Text } from '@amzn/storm-ui';
import { F as FeedbackFormField } from './FeedbackFormField-BQYTqZo2.js';
import { n as noop } from '../LocalModules/storm-ui-utils/dist/esm/noop-BNkHXPFl-BNkHXPFl.js';

const DisclaimerContainer = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-storm-ui-30062554__sc-qq9j67-0"
})(["padding-block-start:4px;"]);
const MessageText = /*#__PURE__*/styled(Text).withConfig({
  componentId: "sc-storm-ui-30062554__sc-qq9j67-1"
})(["margin-block-end:5px;"]);
const DisclaimerForFeedbackForm = ({
  defaultValue,
  disabled,
  id,
  label,
  name,
  onChange,
  renderMessage,
  validateOnMount,
  ...restProps
}) => /*#__PURE__*/React__default.createElement(FeedbackFormField, {
  validateOnMount: validateOnMount,
  name: name,
  id: id,
  defaultValue: defaultValue !== null && defaultValue !== void 0 ? defaultValue : false
}, ({
  id: inputId,
  isSubmitting,
  onChange: internalOnChange,
  value: internalValue
}) => {
  const handleChange = event => {
    internalOnChange(event.target.checked);
    if (typeof onChange === 'function') {
      onChange(event);
    }
  };
  return /*#__PURE__*/React__default.createElement(DisclaimerContainer, null, renderMessage && /*#__PURE__*/React__default.createElement(MessageText, {
    fontSize: "mini",
    textColor: "tertiary"
  }, typeof renderMessage === 'function' ? renderMessage() : renderMessage), /*#__PURE__*/React__default.createElement(Checkbox, _extends({}, restProps, {
    id: inputId,
    label: /*#__PURE__*/React__default.createElement(Text, {
      fontSize: "small",
      textColor: "tertiary"
    }, label),
    checked: internalValue,
    disabled: disabled || isSubmitting,
    onChange: handleChange
  })));
});
DisclaimerForFeedbackForm.propTypes = {
  defaultValue: PT.bool,
  disabled: PT.bool,
  id: PT.string.isRequired,
  label: PT.string.isRequired,
  name: PT.string.isRequired,
  onChange: PT.func,
  renderMessage: PT.func,
  validateOnMount: PT.bool
};
DisclaimerForFeedbackForm.defaultProps = {
  defaultValue: undefined,
  disabled: false,
  onChange: noop,
  renderMessage: undefined,
  validateOnMount: true
};

export { DisclaimerForFeedbackForm as D };
//# sourceMappingURL=DisclaimerForFeedbackForm-BrsM35WT.js.map
